export
const name: string = "Billboard";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3  a_position;
    attribute float a_visibility;
    attribute float a_manipulation;
    attribute vec3  a_position_offset;
    #if defined(TEXTURED)
        attribute vec2  a_tex_coord;
    #endif

    #if !defined(DEPTH_PASS)
        attribute vec3  a_normal;
    attribute float a_selection;
    #endif

    uniform mat4    u_view_matrix_matrix;
    uniform mat4    u_projection_matrix;
    uniform mat4    u_model_transformation; // this supply the model in model view projectionm matrix as we do not have per mesh model trafo, but met fat model
    uniform mat4    u_manipulator;
`;

export
const varyings: string = `
    varying vec2    v_tex_coord;

    #if !defined(DEPTH_PASS)
        varying float   v_selected;
    #endif
`;

export
const implementation: string = `
    void main()
    {
        vec4 position = vec4(a_position_offset, 1.0) * a_visibility;

    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            position = u_manipulator * position;
        }
    #endif

    #if defined(TEXTURED)
        v_tex_coord = a_tex_coord;
    #endif

    #if !defined(DEPTH_PASS)
        v_selected  = a_selection;
    #endif

        vec4 clipSpacePosition = u_projection_matrix * (u_view_matrix_matrix * u_model_transformation * position);

    #if !defined(DEPTH_PASS)
        setVaryingsForLighting2(a_normal, u_model_transformation * position, clipSpacePosition);
    #endif

    #ifdef CLIPPING_PLANE
        setVaryingsForCPlane(u_model_transformation * position);
    #endif

        // we need input for the log depth in gl_Position
        gl_Position = clipSpacePosition;

    #if !defined(DEPTH_PASS) && defined(LOGDEPTH)
        setVaryingsForLogarithmicDepthBuffer();
    #endif

        // get rid of perspective division (keep scale independednt on distance from camera)
        gl_Position = (gl_Position / gl_Position.w) + vec4((a_position.xy / gl_Position.w)* a_visibility, 0.0, 0.0);
        if (gl_Position.z < 0.0){
            gl_Position = vec4(0.0);
        }
    }
`;
